import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgKeyFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.065 15.065A3.066 3.066 0 0 1 4 12.005a3.07 3.07 0 0 1 3.065-3.07 3.07 3.07 0 0 1 3.064 3.07 3.065 3.065 0 0 1-3.064 3.06m13.141-4.06h-8.178a5.07 5.07 0 0 0-4.963-4.07A5.074 5.074 0 0 0 2 12.005c0 2.79 2.272 5.06 5.065 5.06a5.07 5.07 0 0 0 4.963-4.06H16v2.48a1 1 0 1 0 2 0v-2.48h2v2.48a1 1 0 1 0 2 0v-2.69c0-.987-.805-1.79-1.794-1.79"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgKeyFilled);
export default ForwardRef;
